import { View } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { LivenessQuickStart } from "./components/Liveness";
import { useEffect } from "react";

function App({ Component, pageProps }) {
  const urlParams = new URLSearchParams(window.location.search);
  const primaryColor = urlParams.get("primary");
  const variant = urlParams.get("variant");
  const instructions = urlParams.get("instructions");
  const language = urlParams.get("language");

  useEffect(() => {
    if (language) sessionStorage.setItem("language", language);
  }, [language]);

  return (
    <View width="100vw" margin="0 auto">
      {primaryColor && instructions ? (
        <LivenessQuickStart
          variant={variant}
          primaryColor={primaryColor}
          instructions={instructions}
        />
      ) : (
        <></>
      )}
    </View>
  );
}

export default App;
